import { Bot, User, Wrench, CheckCircle2, AlertTriangle, Loader2 } from "lucide-react";

const TOOL_LABELS = {
  list_resources: "عرض الموارد", create_resource: "إنشاء عنصر", update_resource: "تعديل عنصر", delete_resource: "حذف عنصر",
  get_stats: "جلب الإحصائيات", calculate: "حساب", get_time: "الوقت", integrations_status: "حالة التكاملات",
};

const summarize = (t) => {
  const r = t.result || {};
  if (r.error) return r.error;
  if (t.name === "create_resource") return `تم إنشاء ${t.args?.resource}: ${Object.values(r.created || {}).find((v) => typeof v === "string" && v.length < 60) || ""}`;
  if (t.name === "update_resource") return `تم تعديل ${t.args?.resource}`;
  if (t.name === "delete_resource") return `تم الحذف من ${t.args?.resource}`;
  if (t.name === "list_resources") return `${r.count ?? 0} عنصر من ${t.args?.resource}`;
  if (t.name === "calculate") return `${t.args?.expression} = ${r.result}`;
  if (t.name === "get_time") return `${r.timezone}: ${r.time}`;
  if (t.name === "get_stats") return "تم جلب إحصائيات المصانع";
  if (t.name === "integrations_status") return `${Object.values(r).filter(Boolean).length} تكامل مربوط`;
  return "";
};

function ToolCard({ t, pending }) {
  const err = t.result?.error;
  return (
    <div data-testid="tool-card" className={`flex items-center gap-2 rounded-lg border px-3 py-2 text-xs ${err ? "border-red-500/30 bg-red-500/10 text-red-200" : pending ? "border-white/10 bg-white/5 text-slate-300" : "border-emerald-500/25 bg-emerald-500/10 text-emerald-200"}`}>
      {pending ? <Loader2 size={13} className="animate-spin" /> : err ? <AlertTriangle size={13} /> : <CheckCircle2 size={13} />}
      <span className="font-semibold">{TOOL_LABELS[t.name] || t.name}</span>
      {!pending && <span className="text-slate-300/80 truncate">{summarize(t)}</span>}
    </div>
  );
}

export function MessageBubble({ m, color }) {
  const isUser = m.role === "user";
  return (
    <div className={`flex gap-3 fade-up ${isUser ? "flex-row-reverse" : ""}`} data-testid={`message-${m.role}`}>
      <div className={`h-9 w-9 shrink-0 rounded-xl grid place-items-center border ${isUser ? "bg-white/5 border-white/10 text-slate-300" : "border-white/10"}`}
        style={!isUser ? { background: `${color}1a`, color, borderColor: `${color}44` } : {}}>
        {isUser ? <User size={16} /> : <Bot size={16} />}
      </div>
      <div className={`max-w-[85%] space-y-2 ${isUser ? "items-end" : ""}`}>
        {m.tools?.length > 0 && (
          <div className="space-y-1.5">
            {m.tools.map((t, i) => <ToolCard key={i} t={t} pending={t.pending} />)}
          </div>
        )}
        {(m.content || m.streaming) && (
          <div className={`rounded-2xl px-4 py-3 text-sm leading-7 whitespace-pre-wrap ${isUser ? "bg-cyan-400/10 border border-cyan-400/20 text-slate-100" : "bg-white/[0.04] border border-white/[0.07] text-slate-200"}`}>
            {m.content}
            {m.streaming && !m.content && (
              <span className="inline-flex gap-1 items-center"><Wrench size={12} className="text-slate-500" /><span className="typing-dot">●</span><span className="typing-dot">●</span><span className="typing-dot">●</span></span>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
